<template>
    <div id="advert-manage">
        <div class="breadcrumb">
            <span>信息流广告 > </span>
            <span>{{advertTitle}}</span>的信息流广告
            <el-button class="right_f" type="primary" @click="cancle">返回</el-button>
            <el-button class="right_f" type="primary" @click="addNewAdvert()">新增</el-button>
        </div>
        <div class="search-box">
            <el-select v-model="osType" class="com-select">
                <el-option label="全部" value='0'></el-option>
                <el-option label="安卓" value='1'></el-option>
                <el-option label="IOS" value='2'></el-option>
            </el-select>
            <el-select v-model="status" class="com-select">
                <el-option label="全部状态" value='0'></el-option>
                <el-option label="已上线" value='3'></el-option>
                <el-option label="待上线" value='2'></el-option>
                <el-option label="草稿" value='1'></el-option>
                <el-option label="过期" value='4'></el-option>
            </el-select>

            <div class="el-input">
                <el-input type="text" placeholder="搜索名称关键字" v-model="keyWord" @keyup.enter="getStramAdlist"></el-input>
            </div>

            <el-button type="primary" @click="getStramAdlist">搜索</el-button>
        </div>
        <div class="com-list">
            <el-table :data="advertList" style="overflow-x: auto;">
                <el-table-column prop="index" label="序号"></el-table-column>
                <el-table-column prop="title" label="广告标题"></el-table-column>
                <el-table-column prop="description" label="广告说明"></el-table-column>
                <el-table-column prop="osType" label="终端"></el-table-column>
                <el-table-column prop="applicableCampus" label="适用学校"></el-table-column>
                <el-table-column prop="grade" label="等级"></el-table-column>
                <el-table-column prop="showtime" label="有效时间" width="120"></el-table-column>
                <el-table-column inline-template label="状态">
                    <div>
                        <span v-if="row.status == 1">草稿</span>
                        <span v-if="row.status == 2">待上线</span>
                        <span v-if="row.status == 3">已上线</span>
                        <span v-if="row.status == 4">过期</span>
                    </div>
                </el-table-column>
                <el-table-column prop="latestdo" label="最近操作记录" width="200"></el-table-column>
                <el-table-column inline-template label="操作" width="160">
                    <div class="btn-box">
                        <el-button v-if="row.status == 3" type="text" @click="offLineAdvert(row)">下线</el-button>
                        <el-button v-if="row.status != 3" type="text" @click="addNewAdvert(row.id)">编辑</el-button>
                        <el-button v-if="row.status != 3" type="text" @click="deleteAdvert(row)">删除</el-button>
                        <el-button type="text" @click="toStatisData(row)">数据</el-button>
                    </div>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination v-show="totalCount > 0" layout="prev, pager, next, jumper" :page-size="pageSize"
                :current-page="pageNum" :total="totalCount" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                advertType: 0,
                advertTitle: '',
                status: '0',
                osType: '0',
                keyWord: '',
                totalCount: 0,
                pageSize: 20,
                pageNum: 1,
                advertList: [],

            }
        },
        mounted() {
            this.advertType = this.$util.getUrlParam('advertType');
            if (this.advertType == 0) {
                this.advertTitle = '动态';
            } else if (this.advertType == 1) {
                this.advertTitle = '文章';
            } else if (this.advertType == 2) {
                this.advertTitle = '话题';
            } else {
                this.advertTitle = '通知';
            }

            this.getStramAdlist();
        },
        methods: {
            getStramAdlist() {
                let url = this.$util.domain + '/information/stream/adList';
                this.advertList = [];

                this.$http({
                    method: 'POST',
                    url: url,
                    body: JSON.stringify({
                        condition: this.keyWord.trim(),
                        osType: this.osType,
                        type: this.advertType,
                        status: this.status,
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    })
                }).then(response => {
                    if (response.data.error === 10000) {
                        let preObj = response.data.data;
                        this.totalCount = preObj.count;
                        let list = preObj.list;
                        if (list && list.length) {
                            list.forEach((item, index) => {
                                let osType = item.osType == 0 ? '全部' : item.osType == 1 ? '安卓' : 'IOS',
                                    applicableCampus = item.applicableCampus == 0 ? '全部' : '部分',
                                    showtime = new Date(item.startTime).format('yyyy.MM.dd') + '-' +
                                    new Date(item.endTime).format('yyyy.MM.dd'),
                                    grade = item.grade == 0 ? '高' : item.grade == 1 ? '中' : '低';

                                this.advertList.push({
                                    index: index + 1,
                                    id: item.id,
                                    title: item.title,
                                    description: item.description,
                                    osType: osType,
                                    latestdo: item.operationName + ' ' + item.operationTime,
                                    applicableCampus: applicableCampus,
                                    grade: grade,
                                    startTime: new Date(item.startTime).format('yyyy.MM.dd'),
                                    endTime: new Date(item.endTime).format('yyyy.MM.dd'),
                                    showtime: showtime,
                                    status: item.status,
                                    operationName: item.operationName,
                                    operationTime: item.operationTime
                                })
                            });
                        }
                    } else {
                        this.$util.errorMsg('请求失败');
                    }
                })
            },
            addNewAdvert(id) {
                let adid = '';
                if (id) {
                    adid = id;
                }
                location.href = '/#/yunying/advert/newAdvert?advertType=' + this.advertType + '&id=' + adid;
            },
            deleteAdvert(row) { // 删除
                let operatorId = this.$store.state.user.userId;
                let name = this.$store.state.user.name;
                let url = this.$util.domain + '/information/stream/adDelete/' + row.id + '?operatorId=' + operatorId +
                    '&name=' + name;
                this.$confirm('你确定要删除此条广告吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        method: 'GET',
                        url: url,
                    }).then(response => {
                        if (response.data.error === 10000) {
                            this.getStramAdlist();
                        } else {
                            this.$util.errorMsg('操作失败');
                        }
                    })
                })

            },

            offLineAdvert(row) { // 下线
                let operatorId = this.$store.state.user.userId;
                let name = this.$store.state.user.name;
                let url = this.$util.domain + '/information/stream/adOffLine/' + row.id + '?operatorId=' + operatorId +
                    '&name=' + name;
                this.$confirm('你确定要下线此条广告吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        method: 'GET',
                        url: url,
                    }).then(response => {
                        if (response.data.error === 10000) {
                            this.getStramAdlist();
                        } else {
                            this.$util.errorMsg('操作失败');
                        }
                    })
                })

            },
            // 数据
            toStatisData(row) {
                location.href = '/#/yunying/advert/advertData?advertType=' + this.advertType + '&id=' + row.id;
            },
            cancle() {
                location.href = '/#/yunying/advert/advertType'
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getStramAdlist();
            }
        }
    }
</script>
<style scoped>
    .search-box {
        margin-left: 20px;
        margin-bottom: 20px;
    }

    .com-select {
        display: inline-block;
        width: 160px;
    }

    .el-input {
        display: inline-block;
        width: 320px;
    }
</style>


// WEBPACK FOOTER //
// advertManage.vue?042c70d4